export interface TransactOpportunity {
    in: TransactOpportunityInput;
    out: Out;
}

export interface TransactOpportunityModel {
    hasError: boolean;
    errorMessage: string;
    out: Out;
}

export interface Out {
    status: string;
    message: string;
    sales_order_number: string;
}

export class TransactOpportunityInput {
    partner_csn: string;
    partner_po_number: string;
    partner_po_date: string;
    contract_number: string;
    opportunity_number: string;
    end_customer: EndCustomer;
    ship_to: ShipTo;
    reseller: Reseller;
    soldTo: SoldTo;
    line_items: LineItems[];
}

export class EndCustomer {
    account: Account;
    contract_manager: ContractManager;
}

export class Account {
    csn: string;
    company_name: string;
    address_line_1: string;
    address_line_2: string;
    address_line_3: string;
    city: string;
    state: string;
    country_code: string;
    postcode: string;
}

export class ContractManager {
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    country_code: string;
}

export class ShipTo {
    csn: string;
    company_name: string;
    address_line_1: string;
    address_line_2: string;
    city: string;
    state: string;
    postcode: string;
    country_code: string;
}

export class Reseller {
    csn: string;
    email: string;
    account_code: string;
}

export class SoldTo {
    csn: string;
}
export interface LineItems {
    renewal_sku: string;
    sku_description: string;
    serial_number: string;
    quantity: string;
    unit_price: string;
}

export class LineItemObj {
    renewal_sku: string;
    sku_description: string;
    serial_number: string;
    quantity: string;
    unit_price: string;
}